<section class="location-required" aria-labelledby="location-required-title">
  <div class="location-icon" aria-hidden="true">
    <i class="pi pi-map-marker"></i>
  </div>

  <h1 id="location-required-title">
    <app-translate key="LOCATION_CHECK_REQUIRED"></app-translate>
  </h1>

  <p>
    <app-translate key="ENABLE_LOCATION_SERVICES"></app-translate>
  </p>

  <button pButton type="button" class="p-button-primary settings-button" (click)="retryLocation()">
    <app-translate key="OPEN_BROWSER_SETTINGS"></app-translate>
  </button>

  <button #cancelSecureData type="button" class="cancel-secure-data" (click)="openCancelDialog()">
    <app-translate key="CANCEL_SECURE_DATA"></app-translate>
  </button>
</section>

<app-confirm-popup [header]="'CONFIRM_CANCELLATION' | translate" [title]="'SECURE_DATA_CANCELS_ORDER' | translate"
  [buttonLabel]="'CONFIRM' | translate" [buttonLabel2]="'CANCEL' | translate" [(isVisible)]="showCancelDialog"
  (isVisibleChange)="onCancelDialogVisibilityChange($event)" (Result)="onCancelDialogResult($event)">
</app-confirm-popup>

<div class="location-enable-container">
  <p-dialog header="Please enable your location to proceed." [(visible)]="chromeLocationDisabled" [modal]="true"
    [position]="'center'" [style]="{width: '52vw', 'max-height': '90vh'}" [draggable]="false" [resizable]="false">
    <p class="font-bold">
      Enabling Location Services on Google Chrome (Desktop):
    </p>
    <ol>
      <li>Open Google Chrome on your computer or mobile device.</li>
      <li>Click the three vertical dots in the top-right corner to open the menu.</li>
      <li>Select "Settings" from the select menu.</li>
      <li>Scroll down and click "Privacy and Security" to access more settings.</li>
      <li>In the "Privacy and security" section, click on "Site settings".</li>
      <li>Scroll down and select "Location".</li>
      <li>Toggle the switch to enable location permissions for websites.</li>
      <li>To manage permissions for specific websites, use the "Add" button next to the "Block" or "Allow" lists.
      </li>
      <li>To completely disable location permissions, toggle the main switch to off.</li>
    </ol>
    <p class="font-bold pt-3">
      Enabling Location Services on Google Chrome (IOS):
    </p>
    <ng-container *ngTemplateOutlet="iosDefaultTemplate">
    </ng-container>
    <div class="flex justify-content-end mt-4">
      <button label="OKAY" pButton pRipple (click)="chromeLocationDisabled = false" size="small">
      </button>
    </div>
  </p-dialog>

  <p-dialog header="Please enable your location to proceed." [(visible)]="firefoxLocationDisabled" [modal]="true"
    [position]="'center'" [style]="{width: '52vw', 'max-height': '90vh'}" [draggable]="false" [resizable]="false">
    <p class="font-bold">
      Enabling Location Services on Mozilla Firefox (Desktop):
    </p>
    <ol>
      <li>Open Mozilla Firefox on your computer or mobile device.</li>
      <li>Click the three horizontal lines in the top-right corner to open the menu.</li>
      <li>Choose "Settings" from the select menu.</li>
      <li>In the left-hand menu, select "Privacy & Security."</li>
      <li>Scroll to the "Permissions" section and click on "Settings" next to "Location."</li>
      <li>Check the option "Allow websites to ask for your physical location."</li>
      <li>You can also manage exceptions by clicking on the "Exceptions…" button.</li>
    </ol>
    <p class="font-bold pt-3">
      Enabling Location Services on Mozilla Firefox (IOS):
    </p>
    <ng-container *ngTemplateOutlet="iosDefaultTemplate">
    </ng-container>
    <div class="flex justify-content-end mt-4">
      <button label="OKAY" pButton pRipple (click)="firefoxLocationDisabled = false" size="small">
      </button>
    </div>
  </p-dialog>

  <p-dialog header="Please enable your location to proceed." [(visible)]="safariLocationDisabled" [modal]="true"
    [position]="'center'" [style]="{width: '52vw', 'max-height': '90vh'}" [draggable]="false" [resizable]="false">
    <p class="font-bold">
      Enabling Location Services on Safari (Desktop):
    </p>
    <ol>
      <li>Open Safari on your Mac</li>
      <li>Click on "Safari" in the top menu bar and select "Settings."</li>
      <li>In the Preferences window, go to the "Websites" tab.</li>
      <li>In the left-hand sidebar, select "Location."</li>
      <li>Ensure the checkbox next to "Allow websites to request access to your location" is checked.</li>
      <li>Decide whether to allow all websites or only specific ones to access your location.</li>
      <li>Manage individual website settings by selecting them from the list and choosing "Deny," "Prompt," or
        "Allow."</li>
    </ol>
    <p class="font-bold pt-3">
      Enabling Location Services on Safari (IOS):
    </p>
    <ng-container *ngTemplateOutlet="iosDefaultTemplate">
    </ng-container>
    <div class="flex justify-content-end mt-4">
      <button label="OKAY" pButton pRipple (click)="safariLocationDisabled = false" size="small">
      </button>
    </div>
  </p-dialog>

  <p-dialog header="Please enable your location to proceed." [(visible)]="edgeLocationDisabled" [modal]="true"
    [position]="'center'" [style]="{width: '52vw', 'max-height': '90vh'}" [draggable]="false" [resizable]="false">
    <p class="font-bold">
      Enabling Location Services Microsoft Edge (Desktop):
    </p>
    <ol>
      <li>Open Microsoft Edge.</li>
      <li>Click the three horizontal dots in the top-right corner to open a menu.</li>
      <li>Click on "Settings" from the menu.</li>
      <li>Click on "Privacy, search, and services" in the left-hand sidebar.</li>
      <li>Scroll down to the "Site permissions" section.</li>
      <li>Click on "All sites" section.</li>
      <li>Search for saraplus.com in the list of sites.</li>
      <li>Click on saraplus.com to open its settings.</li>
      <li>Ensure the toggle switch next to "Location" is turned on.</li>
      <li>Refresh the saraplus.com page.</li>
    </ol>
    <p class="font-bold pt-3">
      Enabling Location Services on Microsoft Edge (IOS):
    </p>
    <ng-container *ngTemplateOutlet="iosDefaultTemplate">
    </ng-container>
    <div class="flex justify-content-end mt-4">
      <button label="OKAY" pButton pRipple (click)="edgeLocationDisabled = false" size="small">
      </button>
    </div>
  </p-dialog>
</div>

<ng-template #iosDefaultTemplate>
  <ol>
    <li>
      <p>To allow Safari to access your location, you can do the following:</p>
      <ol type="a">
        <li>Open the Settings app.</li>
        <li>Tap Privacy & Security.</li>
        <li>Tap Location Services.</li>
        <li>Ensure Location Services is turned on.</li>
        <li>Scroll down and tap Safari Websites.</li>
        <li>
          <p>Select your preferred option:</p>
          <ol type="i">
            <li>While Using the App</li>
            <li>Ask Next Time or When I Share</li>
            <li>Never</li>
          </ol>
        </li>
      </ol>
    </li>
    <li>
      <p>For best results, choose “While Using the App” to allow Safari to access your location when needed.</p>
    </li>
  </ol>
</ng-template>